import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterAbility,
  AbilityEffect,
  Potence,
  // SummonOption2,
  CharacterFeatureSource,
  Transform,
  CharacterSpell,
  Attack,
  CreatureTransform,
  ExtraEffectsFeature,
  CharacterFeature,
  CharacterSheetInterface,
  CreatureInstance,
  SummonInstance,
  ExtraEffectsOfTypeFeature,
  CharacterAction,
  CharacterItem,
  StoredSpell
} from "@dndModels";
import {
  ALL_DRAGONS,
  DAMAGE_TYPES,
  DRACONIC_DAMAGE_TYPES,
  EFFECT_TYPES
} from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";
import CommonUtilities from "@utilities/common_utilities";

import DisplayObjects from "@dndComponents/display/DisplayObjects";
import LoadingBox from "@components/input/LoadingBox";
import ImageFromString from "@dndComponents/display/ImageFromString";
import { DamageType, EffectType } from "@dndModels/Types";
import { SmartHash } from "@models";

interface Props {
  character?: Character;
  char_int: CharacterSheetInterface | CreatureInstance | SummonInstance;
  spell?: CharacterAbility | CharacterSpell | StoredSpell;
  action: CharacterAction;
  effect: AbilityEffect;
  log_it?: boolean;
  ee_cf?: CharacterFeature;
  level: number;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CharacterEffectPDF({
  character,
  char_int,
  spell,
  action,
  effect,
  log_it = false,
  ee_cf,
  level,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [transforms, setTransforms] = useState<Transform[]>([]);
  // const [adaptations, setAdaptations] = useState<Adaptation[]>([]);

   
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const load = () => {
    setLoading(true);
    setFetched(true);
    const onComplete = (res: SmartHash) => {
      if (res && !res.error) {
        setTransforms(res.transform as Transform[]);
        // setAdaptations(res.adaptation as Adaptation[]);
        setLoading(false);
      }
    };
    const onProgress = () => {};
    api.getSetOfObjectsWithCallbacks({ 
      data_types: ["transform"],
      onComplete, onProgress 
    });
  }

  const effectType = () => {
    let effect_type: EffectType | DamageType = effect.type;
    if (effect_type === "Selectable Key") {
      const key = effect.selectable_key;
      let cfs: CharacterFeatureSource | null = null;
      if (spell && !(spell instanceof StoredSpell)) {
        switch (spell.source_type) {
          case "Race": 
            if (character) {
              cfs = character.race; 
            }
          break;
          default:
            console.log(spell);
            console.log(key);
            console.log(effect);
            console.log(character);
          break;
        }
      }
      if (cfs && cfs.selectable_hash[key] && EFFECT_TYPES.includes(cfs.selectable_hash[key][0])) {
        effect_type = cfs.selectable_hash[key][0] as EffectType;
        if (effect.selectable_type === "Damage Type" && 
          ALL_DRAGONS.includes(effect_type)) {
          effect_type = (DRACONIC_DAMAGE_TYPES as any)[effect_type] as DamageType;
        }
      }
    }
    return effect_type;
  }

  const renderSummonControls = (potence: Potence) => {
    // const summon_options = potence.summon_options;
    // let summon_option_list: SummonOption2[] = []; 
    // if (summon_options.filter(o => !o.custom).length === 0) {
    //   summon_option_list = potence.summon_option_list([]);
    // }
    // const option = summon_option_list.length === 1 ? summon_option_list[0] : null;
    const effect_type = effectType();
    const range_string = char_int instanceof CreatureInstance || char_int instanceof SummonInstance ? "range_string not implemented" : (spell instanceof Attack ? "Self" : char_util.getRangeString({ char_int: char_int, spell, effect }));
    return (
      <Grid className="centered"
        container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 5
          }}>
          { range_string }
        </Grid>
        <Grid
          size={{
            xs: 3
          }}>
          {/* { summon_option_list.length !== 1 ?
            "Choose a Creature"
          : option &&
            <span>{ option.name }</span>
          } */}
          Summon
        </Grid>
        <Grid
          size={{
            xs: 4
          }}>
          {effect_type}
        </Grid>
      </Grid>
    );
  }

  const renderTransformControls = (potence: Potence) => {
    // if (spell instanceof CharacterAbility && spell.name.includes("Wild")) {
    //   debugger;
    // }
    console.log(transforms);
    const filtered: Transform[] = []; // api.filter("", transforms, potence.obj_filter);
    // if (potence.knowledge_usage_key.length > 0 && character) {
    //   filtered = filtered.filter(o => 
    //     character.knowledge.filter(o2 => 
    //       o2.obj_id === o._id && 
    //       o2.type === "Transform" && 
    //       o2.usage === potence.knowledge_usage_key
    //     ).length > 0
    //   );
    // }
    const selected_transform = filtered.length === 1 ? filtered[0] : null;
    const selected_transform_id = selected_transform ? selected_transform._id : "";
    const range_string = char_int instanceof CreatureInstance || char_int instanceof SummonInstance ? "range_string not implemented" : (spell instanceof Attack ? "Self" : char_util.getRangeString({ char_int: char_int, spell, effect }));
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="centered"
          size={{
            xs: 5
          }}>
          { range_string }
        </Grid>
        { (filtered.length > 1 || !(selected_transform instanceof CreatureTransform)) &&
          <Grid
            className="centered"
            size={{
              xs: 3
            }}>
            { filtered.length === 1 ? 
              <DisplayObjects type="transform" ids={[selected_transform_id]} /> 
            :
              "Choose a Transform"
            }
          </Grid> 
        }
        { selected_transform instanceof CreatureTransform ? 
          <>
            { filtered.length === 1 && !reloading ? 
              <>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>
                  { selected_transform.name }
                </Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 4
                  }}>
                  Transform
                </Grid>
              </>
            : !reloading && 
              <>
                <Grid
                  className="centered"
                  size={{
                    xs: 4
                  }}>
                  Transform
                </Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 12
                  }}>
                  { selected_transform.name }
                </Grid>
              </>
            }
          </>
        :
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
            Transform
          </Grid>
        }
      </Grid>
    );
  }

  // const renderAdaptationControls = (potence: Potence) => {
  //   // debugger;
  //   console.log(adaptations);
  //   let filtered: Adaptation[] = []; // api.filter("", adaptations, potence.obj_filter);
  //   // if (potence.knowledge_usage_key.length > 0 && character) {
  //   //   filtered = filtered.filter(o => 
  //   //     character.knowledge.filter(o2 => 
  //   //       o2.obj_id === o._id && 
  //   //       o2.type === "Adaptation" && 
  //   //       o2.usage === potence.knowledge_usage_key
  //   //     ).length > 0
  //   //   );
  //   // }
  //   const selected_adaptation = filtered.length === 1 ? filtered[0] : null;
  //   return (
  //     <Grid container spacing={0} direction="row">
  //       <Grid item xs={5} className="centered">
          
  //       </Grid>
  //       <Grid item xs={3} className="centered">
  //         { filtered.length === 1 && selected_adaptation ? 
  //           <DisplayObjects type="adaptation" ids={[selected_adaptation._id]} /> 
  //         :
  //           "Adaptation"
  //         }
  //       </Grid>
  //       <Grid item xs={4} className="centered">
  //         Adapt
  //       </Grid>
  //     </Grid>
  //   );
  // }

  const renderCreateResourceControls = (potence: Potence) => {
    if (character) {
      const amount = potence.create_resource.amount;
      if (spell && !(spell instanceof CharacterItem || spell instanceof Attack)) {
        // if (spell.name.includes("Absorption")) {
        //   debugger;
        // }
        const effect_type = effectType();
        const flat = char_util.value(amount.flat, { obj: character, source_id: spell.source_true_id, root_id: spell.source_true_id, action });
        const count = char_util.value(amount.count, { obj: character, source_id: spell.source_true_id, root_id: spell.source_true_id, action });
        const size = char_util.value(amount.size, { obj: character, source_id: spell.source_true_id, root_id: spell.source_true_id, action });
        const up_to_max = char_util.value(potence.create_resource.up_to_max, { obj: character, source_id: spell.source_true_id, root_id: spell.source_true_id, action });
        if (size !== null && count !== null && flat !== null) {
          let str = effect.refresh_only ? "Refresh " : "Create ";
          if (size > 1 && count > 0) {
            str += `${count}d${size}` + (flat === 0 ? "" : `+${flat}`);
            // let maxed = false;
            if (up_to_max > 0) {
              str += ` up to ${up_to_max}`;
              // if (potence.create_resource.resource_type === "Slot") {
              //   // I'm never going to use it for Slots, or am I?
              //   debugger;
              // } else {
              //   const resource_finder = character.resources.filter(o => o.type_id === potence.create_resource.resource_type);
              //   if (resource_finder.length === 1) {
              //     const resource = resource_finder[0];
              //     maxed = resource.available >= up_to_max;
              //   }
              // }
            }
            str += " ";
            if (potence.create_resource.resource_type === "Slot") {
              str += `Level ${ potence.create_resource.level } Slot`;
            } else if (potence.create_resource.resource_type === "Charge") {
              str += `Charge`;
            }
            return (
              <Grid className="centered"
                container spacing={0} direction="row">
                <Grid
                  className="centered"
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 4
                  }}>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    { str }
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    { potence.create_resource.resource_type !== "Slot" && potence.create_resource.resource_type !== "Charge" &&
                      <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} />
                    }
                  </Grid>
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}></Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  {effect_type}
                </Grid>
              </Grid>
            );
          } else if (flat) {
            // let maxed = false;
            if (up_to_max > 0) {
              str += `up to ${up_to_max} `;
              // if (potence.create_resource.resource_type === "Slot") {
              //   // I'm never going to use it for Slots, or am I?
              //   debugger;
              // } else {
              //   const resource_finder = character.resources.filter(o => o.type_id === potence.create_resource.resource_type);
              //   if (resource_finder.length === 1) {
              //     const resource = resource_finder[0];
              //     maxed = resource.available >= up_to_max;
              //   }
              // }
            } else if (flat > 1) {
              str += `${flat} `;
            }
            if (potence.create_resource.resource_type === "Slot") {
              str += `Level ${ potence.create_resource.level } Slot`;
            } else if (potence.create_resource.resource_type === "Charge") {
              str += `Charge`;
            }
            return (
              <Grid className="centered"
                container spacing={0} direction="row">
                <Grid
                  className="centered"
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 4
                  }}>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    { str }
                  </Grid>
                  <Grid
                    size={{
                      xs: 12
                    }}>
                    { potence.create_resource.resource_type !== "Slot" &&
                      <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} display_field={flat === 1 ? "singular" : "name"} />
                    }
                  </Grid>
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}></Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  {effect_type}
                </Grid>
              </Grid>
            );
          }
        }
      } else if (ee_cf) {
        // if (spell.name.includes("Absorption")) {
        //   debugger;
        // }
        const flat = char_util.value(amount.flat, { obj: character, source_id: ee_cf.source_true_id, root_id: ee_cf.source_true_id, action });
        const count = char_util.value(amount.count, { obj: character, source_id: ee_cf.source_true_id, root_id: ee_cf.source_true_id, action });
        const size = char_util.value(amount.size, { obj: character, source_id: ee_cf.source_true_id, root_id: ee_cf.source_true_id, action });
        const up_to_max = char_util.value(potence.create_resource.up_to_max, { obj: character, source_id: ee_cf.source_true_id, root_id: ee_cf.source_true_id, action });
        if (size !== null && count !== null && flat !== null) {
          let str = effect.refresh_only ? "Refresh " : "Create ";
          if (size > 1 && count > 0) {
            str += `${count}d${size}` + (flat === 0 ? "" : `+${flat}`);
            // let maxed = false;
            if (up_to_max > 0) {
              str += ` up to ${up_to_max}`;
              // if (potence.create_resource.resource_type === "Slot") {
              //   // I'm never going to use it for Slots, or am I?
              //   debugger;
              // } else {
              //   const resource_finder = character.resources.filter(o => o.type_id === potence.create_resource.resource_type);
              //   if (resource_finder.length === 1) {
              //     const resource = resource_finder[0];
              //     maxed = resource.available >= up_to_max;
              //   }
              // }
            }
            str += " ";
            if (potence.create_resource.resource_type === "Slot") {
              str += `Level ${ potence.create_resource.level } Slot`;
            } else if (potence.create_resource.resource_type === "Charge") {
              str += `Charge`;
            }
            return (
              <Grid className="centered"
                container spacing={0} direction="row">
                <Grid
                  className="centered"
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 4
                  }}>
                  {/* <Grid item xs={12}>
                    { str }
                  </Grid> */}
                  {/* <Grid item xs={12}>
                    { potence.create_resource.resource_type !== "Slot" && potence.create_resource.resource_type !== "Charge" &&
                      <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} />
                    }
                  </Grid> */}
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}></Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  {str}
                  { potence.create_resource.resource_type !== "Slot" && potence.create_resource.resource_type !== "Charge" &&
                    <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} display_field={flat === 1 ? "singular" : "name"} />
                  }
                </Grid>
              </Grid>
            );
          } else if (flat) {
            // let maxed = false;
            if (up_to_max > 0) {
              str += `up to ${up_to_max} `;
              // if (potence.create_resource.resource_type === "Slot") {
              //   // I'm never going to use it for Slots, or am I?
              //   debugger;
              // } else {
              //   const resource_finder = character.resources.filter(o => o.type_id === potence.create_resource.resource_type);
              //   if (resource_finder.length === 1) {
              //     const resource = resource_finder[0];
              //     maxed = resource.available >= up_to_max;
              //   }
              // }
            } else if (flat > 1) {
              str += `${flat} `;
            }
            if (potence.create_resource.resource_type === "Slot") {
              // debugger;
              str += `Level ${ potence.create_resource.level } Slot`;
            } else if (potence.create_resource.resource_type === "Charge") {
              str += `Charge`;
            }
            return (
              <Grid className="centered"
                container spacing={0} direction="row">
                <Grid
                  className="centered"
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 4
                  }}>
                  {/* <Grid item xs={12}>
                    { str }
                  </Grid> */}
                  {/* <Grid item xs={12}>
                    { potence.create_resource.resource_type !== "Slot" &&
                      <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} display_field={flat === 1 ? "singular" : "name"} />
                    }
                  </Grid> */}
                </Grid>
                <Grid
                  size={{
                    xs: 4
                  }}></Grid>
                <Grid
                  size={{
                    xs: 4
                  }}>
                  {str}
                  { potence.create_resource.resource_type !== "Slot" && potence.create_resource.resource_type !== "Charge" &&
                    <DisplayObjects type="resource" ids={[potence.create_resource.resource_type]} display_field={flat === 1 ? "singular" : "name"} />
                  }
                </Grid>
              </Grid>
            );
          }
        }
      }
    }
    return null;
  }

  let damage_types: DamageType[] = [];
  if (action && action.damage_type_options.length > 0) {
    damage_types = action.damage_type_options;
  } else {
    damage_types = effect.damage_types;
  }

  const renderEffectType = (effect_type: EffectType | DamageType) => {
    if (DAMAGE_TYPES.includes(effect_type)) {
      return (
        <ImageFromString image={effect_type} />
      );
    } else if (effect_type === "Damage") {
      return damage_types.map((dt, key) => {
        return <span key={key}><ImageFromString image={dt} />&nbsp;</span>;
      });
    } else if (effect_type === "Healing" || effect_type === "Temp HP" || effect_type === "Max HP") {
      return (
        <ImageFromString image={effect_type} />
      );
    }
    return null;
  }

  const item_id = spell instanceof CharacterAbility ? spell.item_id : (spell instanceof CharacterSpell ? spell.source_true_id : "");
   
  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    // if (spell instanceof CharacterSpell && spell.name.includes("Spirit")) {
      // debugger;
    // }
    if (log_it) {
      debugger;
    }
    const effect_type = effectType();
    if (["Rollable Table"].includes(effect_type)) {
      return <></>;
    } else if (["Self Condition"].includes(effect_type)) {
      const range_string = char_int instanceof CreatureInstance || char_int instanceof SummonInstance ? "range_string not implemented" : char_util.getRangeString({ char_int: char_int, spell: spell, effect });
      const range_font_size = range_string.length < 15 ? "10px" : "6px";
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="centered"
            style={{ fontSize: range_font_size }}
            size={{
              xs: 5
            }}>
            { range_string }
          </Grid>
          <Grid
            className="centered"
            size={{
              xs: 3
            }}>
          </Grid>
          <Grid
            className="centered"
            size={{
              xs: 4
            }}>
          </Grid>
        </Grid>
      );
    } else if (char_int instanceof CreatureInstance || char_int instanceof SummonInstance) {
      const potence = effect.potences.length > 0 ? effect.potences[0] : null;

      if (potence) {
        if (["Summon"].includes(effect.type)) {
          return renderSummonControls(potence);
        } else if (effect.type === "Transform") {
          return renderTransformControls(potence);
        // } else if (effect.type === "Adaptation") {
        //   return renderAdaptationControls(potence);
        } else if (effect_type === "Create Resource") {
          return <></>;
        }
      }
      let potence_string = ""; 
      if (potence) {
        const size = char_util.value(potence.rolls.size, { obj: char_int, log_it });
        const count = char_util.value(potence.rolls.count, { obj: char_int, log_it });
        const flat = char_util.value(potence.rolls.flat, { obj: char_int, log_it });
        if (size > 1 && count !== 0) {
          potence_string += `${count}d${size}`;
        }
        if (flat !== 0) {
          if (flat > 0) {
            if (potence_string.length > 0) {
              potence_string += `+${flat}`;
            } else {
              potence_string += `${flat}`;
            }
          } else {
            potence_string += `${flat}`;
          }
        }
      }
      let range_string = char_util.getRangeString({ char_int: char_int, spell: spell, effect });
      if (ee_cf) {
        if (ee_cf.floating_feature instanceof ExtraEffectsFeature && !ee_cf.floating_feature.show_range) {
          range_string = "";
        }
        if (range_string.length > 0) {
          range_string += "\r";
        }
        range_string += ee_cf.name;
      }
      let spell_attack = action.attack_mod;
      let spell_dc = action.dc;
      if (spell_attack === 0 && spell_dc === 0) {
        if (spell instanceof CharacterAbility) {
          spell_attack = spell.spell_attack;
          spell_dc = spell.spell_dc;
        }
      }
      if (!["Control","Utility","Summon","Transform","Create Resource","None","Special"].includes(effect_type)) {
        // potence_string
      } else if (["Control","Utility"].includes(effect_type) && effect.utility_detail !== "") {
        potence_string = effect.utility_detail;
      } else {
        potence_string = effect_type; 
      }
      let effect_string = "";
      if (spell && effect.use_attack) {
        effect_string = common_util.addPlusMaybe(spell_attack);
      } else if (spell && effect.attack_type === "Save") {
        effect_string = `${effect.saving_throw_ability_score} ${spell_dc}`;
      }
      const range_font_size = range_string.length < 15 ? "10px" : "6px";
      const effect_font_size = effect_string.length < 15 ? "10px" : "6px";
      const potence_font_size = potence_string.length < 15 ? "10px" : "6px";
      // debugger;
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="centered"
            style={{ fontSize: range_font_size }}
            size={{
              xs: 5
            }}>
            { range_string }
          </Grid>
          <Grid
            className="centered"
            style={{ fontSize: effect_font_size }}
            size={{
              xs: 3
            }}>
            { effect_string }
          </Grid>
          <Grid
            className="centered"
            style={{ fontSize: potence_font_size }}
            size={{
              xs: 4
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                size={{
                  xs: 12
                }}>
                { potence_string }
                { (effect_type !== "Damage" || damage_types.length < 2) && renderEffectType(effect_type) }
              </Grid>
              { (effect_type === "Damage" && damage_types.length > 1) && 
                <Grid
                  size={{
                    xs: 12
                  }}>
                  { renderEffectType(effect_type) }
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      );
    } else if (character) {
      // const potence = effect.potences.length > 0 ? effect.potences[0] : null;
      const potence = ee_cf && (ee_cf.floating_feature instanceof ExtraEffectsFeature || ee_cf.floating_feature instanceof ExtraEffectsOfTypeFeature) ? 
        char_util.getPotence({slot_level: level, char: character, char_int: char_int, item_id, spell: ee_cf, effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), log_it}) : 
        spell ? 
        char_util.getPotence({slot_level: level, char: character, char_int: char_int, item_id, spell, effect, cfs_id: "", action, log_it}) : 
        null;
      if (potence) {
        if (["Summon"].includes(effect.type)) {
          return renderSummonControls(potence);
        } else if (effect.type === "Transform") {
          return renderTransformControls(potence);
        // } else if (effect.type === "Adaptation") {
        //   return renderAdaptationControls(potence);
        } else if (effect_type === "Create Resource") {
          return renderCreateResourceControls(potence);
        }
      }
      let potence_string = ee_cf && ee_cf.floating_feature instanceof ExtraEffectsFeature ? char_util.getPotenceString({slot_level: level, char: character, char_int: char_int, item_id, spell: ee_cf, effect, cfs_id: (ee_cf ? ee_cf.source_id : ""), log_it}) : spell ? char_util.getPotenceString({slot_level: level, char: character, char_int: char_int, item_id, spell, effect, cfs_id: "", action, log_it}) : "";
      if (character.character_options.potion_max_on_action && 
        spell instanceof CharacterAbility && 
        spell.casting_times.includes("A") && spell.char_feature && 
        spell.char_feature.feature && 
        effect.type === "Healing" && 
        spell.source_name.includes("Healing") && potence) {
        // debugger;
        const max = char_util.maxRoll(potence.rolls, { obj: char_int, source_id: spell.source_true_id });
        potence_string = `${max}`; 
      }
      let range_string = char_int instanceof CreatureInstance || char_int instanceof SummonInstance ? "range_string not implemented" : char_util.getRangeString({ char_int: char_int, spell: spell, effect });
      if (ee_cf) {
        if (ee_cf.floating_feature instanceof ExtraEffectsFeature && !ee_cf.floating_feature.show_range) {
          range_string = "";
        }
        if (range_string.length > 0) {
          range_string += "\r";
        }
        range_string += ee_cf.name;
      }
      let spell_attack = 0;
      let spell_dc = 0;
      if (spell instanceof CharacterAbility) {
        spell_attack = spell.spell_attack;
        spell_dc = spell.spell_dc;
      } else if (spell) {
        const source_id = spell.source_id;
        const source = character.classes.find(o => o.source_id === source_id);
        if (source) {
          spell_attack = source.spell_attack;
          spell_dc = source.spell_dc;
        }
      }
      if (!["Control","Utility","Summon","Transform","Create Resource","None","Special"].includes(effect_type)) {
        // potence_string
      } else if (["Control","Utility"].includes(effect_type) && effect.utility_detail !== "") {
        potence_string = effect.utility_detail;
      } else {
        potence_string = effect_type; 
      }
      let effect_string = "";
      if (spell && effect.use_attack) {
        effect_string = common_util.addPlusMaybe(spell_attack);
      } else if (spell && effect.attack_type === "Save") {
        effect_string = `${effect.saving_throw_ability_score} ${spell_dc}`;
      }
      const range_font_size = range_string.length < 15 ? "10px" : "6px";
      const effect_font_size = effect_string.length < 15 ? "10px" : "6px";
      const potence_font_size = potence_string.length < 15 ? "10px" : "6px";
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            className="centered"
            style={{ fontSize: range_font_size }}
            size={{
              xs: 5
            }}>
            { range_string }
          </Grid>
          <Grid
            className="centered"
            style={{ fontSize: effect_font_size }}
            size={{
              xs: 3
            }}>
            { effect_string }
          </Grid>
          <Grid
            className="centered"
            style={{ fontSize: potence_font_size }}
            size={{
              xs: 4
            }}>
            <Grid container spacing={0} direction="row">
              <Grid
                size={{
                  xs: 12
                }}>
                { potence_string }
                { (effect_type !== "Damage" || damage_types.length < 2) && renderEffectType(effect_type) }
              </Grid>
              { (effect_type === "Damage" && damage_types.length > 1) && 
                <Grid
                  size={{
                    xs: 12
                  }}>
                  { renderEffectType(effect_type) }
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      );
    } else {
      return <></>;
    }
  }
}
